<template>
    <div class="rename-modal">
      <transition name="opacity">
        <div class="cover"></div>
      </transition>
      <transition name="box">
        <div class="box">
          <div class="message-header">
            简历名称
            <!-- <i class="message-close iconfont iconx" @click="close"></i> -->
          </div>
          <div class="message-content" style='margin-bottom: 14px;'>
            <div class="message-input-main">
              <input style="width: calc(100% - 40px)" type="text" v-model="name" placeholder="请输入简历名称">
            </div>
            <div class='err-msg' v-if='errorShow' style='margin-bottom: -4px;'>
              <i class='iconfont iconcuowu'></i>
              <span>{{errorMsg}}</span>
            </div>
          </div>
          <div class="message-content">
            <p class="sub-title">选择模块内容，生成专业简历名称</p>
            <div class="select-list flex">
              <div @click="selectLabel(item)" class="select-item" :class="{'is-active': item.checked}" v-for="(item, index) in nameSelect" :key="index">
                {{ item.name }}
              </div>
            </div>
          </div>
          <div class="message-btn">
            <button class="cancel" @click="cancel">取消</button>
            <button class="action" @click="confirm">保存</button>
          </div>
        </div>
      </transition>
    </div>
</template>
<script>
import {mapState, mapMutations} from 'vuex';
import api from '@/api';
export default {
  name: 'renameModal',
  data() {
    return {
      cvNameAlert: false,
      errorMsg: '名称不能包含下列任何字符：+/\<>*?:|""、', // 修改简历名称时校验提示文案
      errorShow: false,
      nameSelect: [],
      cvInfo: {},
      name: '',
      token: '',
      isSava: false
    };
  },
  props: {
    cvToken: {
      type: String,
      default: ''
    },
    cvName: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState('editor', ['cvDetail']),
    ...mapState('cv', ['cvs']),
  },
  created(){
    this.name = this.cvName
    this.token = this.cvToken
    this.getNamePart()
  },
  methods: {
    ...mapMutations('editor',['setCvDetail']),
    ...mapMutations("cv",["setCvs"]),
    close() {
      this.$emit('editCvName', '', this.name)
    },
    cancel() {
      this.$emit('editCvName', '', this.cvName)
    },
    confirm() {
      this.saveSetting()
    },
    async getNamePart () {
      let res = await api.cvsEditor.getCvNamePart(this.token)
      if (res.code === 1000) {
        this.nameSelect = res.data.options
      }
    },
    // 选择简历名称的label
    selectLabel (item) {
      item.checked = !item.checked
      if (item.checked) {
        this.name += `_${ item.display_name }`
      } else {
        let name = new RegExp(`_${ item.display_name }|${ item.display_name }`, 'gi')
        this.name = this.name.replace(name, '')
      }
      if (this.name.substr(0, 1) === '_') this.name = this.name.slice(1)
      this.$forceUpdate()
    },
    // 保存设置名称
    async saveSetting (save) {
      if (this.isSava) return
      this.isSava = true
      let reg = /[+/\\<>*?:|"、]/im
      if (reg.test(this.name)) {
        this.errorShow = true
        return
      }
      this._saveCvName()
    },
    // 更新简历名称的接口
    async _saveCvName () {
      let name_parts = this.nameSelect.filter(v => v.checked).map(v => v.value)
      let res = await api.cvsEditor.updatedCvInfo(this.token, {
        operation_type: 'update_basic_info',
        basic_info: {
          cv_name: this.name,
          name_parts
        }
      })
      if (res.code === 1000) {
        let list = JSON.parse((JSON.stringify(this.cvs)))
        list.forEach(item=>{
          if(item.token===this.token){
            item.cv_name = this.name
          }
        })
        this.setCvs(list)
        let cvDetail = JSON.parse(JSON.stringify(this.cvDetail))
        cvDetail.basic_info.cv_name = this.name;
        //标题名称同步到vuex中
        this.setCvDetail(cvDetail);
        this.close()
        this.errorShow = false
        this.$message.success('设置成功');
      }
      this.isSava = false
    }
  }
}
</script>
<style lang="scss" scoped>
  .rename-modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    .cover {
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, .5);
    }
    .box {
      width: 446px;
      height: 330px;
      background: #fff;
      border-radius: 4px;
      position: absolute;
      .message-close {
        font-size: 20px;
        color: #404040;
        font-weight: 600;
        float: right;
        cursor: pointer;
      }
      .message-header {
        height: fit-content;
        // border-bottom: 1px solid #E8E8E8;
        font-size: 18px;
        font-weight: 600;
        color: #404040;
        // line-height: 72px;
        padding: 28px 32px 15px 32px;
      }
      .message-content {
        padding: 0 32px;
        font-size: 14px;
        color: #606060;
        .err-msg{
          display: flex;
          align-items: center;
          margin-bottom: 6px;
          color: #ff4f4c;
          i{
            margin-right: 6px;
          }
        }
        .sub-title{
          color: #909090;
        }
        .select-list{
          flex-wrap: wrap;
          .select-item{
            width: 74px;
            cursor: pointer;
            margin-top: 14px;
            border-radius: 2px;
            height: 28px;
            border: 1px solid #ededed;
            color: #909090;
            line-height: 28px;
            text-align: center;
            margin-right: 14px;
          }
          .select-item.is-active{
            border: 1px solid #ff4f4c;
            color: #ff4f4c;
          }
        }
        .message-input-main {
          margin-bottom: 10px;
          input {
            width: calc(100% - 100px);
            height: 36px;
            border-radius: 2px;
            border: 1px solid #d9d9d9;
            background: transparent;
            padding: 0 18px;
            color: #404040;
          }
        }
      }
      .message-btn {
        text-align: right;
        position: absolute;
        bottom: 32px;
        right: 32px;
        display: flex;
        justify-content: flex-end;
        button {
          display: block;
          width: 84px;
          height: 36px;
          border: 1px solid #D9D9D9;
          border-radius: 2px;
          font-size: 14px;
          color: #606060;
          background: #fff;
          &.action {
            background: #FF4F4C;
            border-color: #FF4F4C;
            color: #fff;
          }
          &.cancel.seccess{
            border-color: #FF4F4C;
            color: #FF4F4C;
          }
          &:last-child {
            margin-left: 16px;
          }
        }
      }
    }
  }
</style>
